/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TCOOutputInteger
 */
export interface TCOOutputInteger {
    /**
     * 
     * @type {number}
     * @memberof TCOOutputInteger
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof TCOOutputInteger
     */
    units: string;
}

export function TCOOutputIntegerFromJSON(json: any): TCOOutputInteger {
    return TCOOutputIntegerFromJSONTyped(json, false);
}

export function TCOOutputIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TCOOutputInteger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'units': json['units'],
    };
}

export function TCOOutputIntegerToJSON(value?: TCOOutputInteger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'units': value.units,
    };
}


